export default defineI18nConfig(() => ({
  fallbackLocale: "ja",
}));
